import React from 'react';
import { cn } from '@/lib/utils';
import { Button } from '@/components/ui/button';

/**
 * EmptyState - Boş liste durumları için reusable component.
 *
 * Kullanım:
 *   <EmptyState
 *     icon={Inbox}
 *     title="Keine Aufgaben"
 *     description="Sie haben aktuell keine offenen Aufgaben."
 *     action={{ label: 'Neue Aufgabe', onClick: () => ... }}
 *   />
 */
export default function EmptyState({
  icon: Icon,
  title,
  description,
  action,
  className,
  compact = false,
}) {
  return (
    <div
      className={cn(
        'flex flex-col items-center justify-center text-center',
        compact ? 'py-8 px-4' : 'py-16 px-6',
        className
      )}
    >
      {Icon && (
        <div
          className={cn(
            'rounded-full bg-slate-100 flex items-center justify-center mb-4',
            compact ? 'w-12 h-12' : 'w-16 h-16'
          )}
        >
          <Icon
            className={cn(
              'text-slate-400',
              compact ? 'w-6 h-6' : 'w-8 h-8'
            )}
            strokeWidth={1.5}
          />
        </div>
      )}
      {title && (
        <h3
          className={cn(
            'font-semibold text-slate-900 mb-1',
            compact ? 'text-sm' : 'text-base'
          )}
        >
          {title}
        </h3>
      )}
      {description && (
        <p
          className={cn(
            'text-slate-500 max-w-sm mb-4',
            compact ? 'text-xs' : 'text-sm'
          )}
        >
          {description}
        </p>
      )}
      {action && (
        <Button
          onClick={action.onClick}
          variant={action.variant || 'default'}
          size={compact ? 'sm' : 'default'}
          className="min-h-[44px]"
        >
          {action.icon && <action.icon className="w-4 h-4 mr-2" />}
          {action.label}
        </Button>
      )}
    </div>
  );
}
